// src/lib/placeEditCache.js
const PLACE_CACHE_PREFIX = "loadevo.place.edit.v1.";
const PLACE_CACHE_TTL_MS = 10 * 60 * 1000; // 10 min

export function readPlaceCache(placeId) {
  try {
    const raw = window.sessionStorage.getItem(`${PLACE_CACHE_PREFIX}${placeId}`);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || !parsed.data) return null;

    // TTL
    const ts = parsed.ts || 0;
    if (Date.now() - ts > PLACE_CACHE_TTL_MS) return null;

    return parsed.data;
  } catch {
    return null;
  }
}

export function writePlaceCache(placeId, data) {
  try {
    window.sessionStorage.setItem(
      `${PLACE_CACHE_PREFIX}${placeId}`,
      JSON.stringify({ ts: Date.now(), data })
    );
  } catch {
    // ignore
  }
}
